import { render, staticRenderFns } from "./amountUnitTip.vue?vue&type=template&id=3d0c5550&scoped=true"
import script from "./amountUnitTip.vue?vue&type=script&lang=js"
export * from "./amountUnitTip.vue?vue&type=script&lang=js"
import style0 from "./amountUnitTip.vue?vue&type=style&index=0&id=3d0c5550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c5550",
  null
  
)

export default component.exports